import { NavigationGuard } from "vue-router";

/**
 * フラグメントありの URL からフラグメントを削除する
 *
 * @param to
 * @param from
 * @param next
 * @returns
 */
export const removeHash: NavigationGuard = (to, _from, next) => {
  if (to.fullPath.startsWith("/#")) {
    // 例: /#/orders/detail?transitionSource=Search から /orders/detail?transitionSource=Search を抜き出す
    const path = to.fullPath.substring(2);
    next(path);
    return;
  }
  next();
};
